namespace GeniuzPOS.Administration {
    export interface SysParaRow {
        Id?: number;
        SysFg?: number;
        SysGroup?: number;
        SysName?: string;
        SysDesc?: string;
        SysFgDesc?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        SysGroup1?: string;
        SysGroupSysGroupDesc?: string;
        SysGroupCreateBy?: string;
        SysGroupCreateDate?: string;
        SysGroupUpdateBy?: string;
        SysGroupLastUpdate?: string;
    }

    export namespace SysParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysName';
        export const localTextPrefix = 'Administration.SysPara';
        export const lookupKey = 'Administration.SysPara';

        export function getLookup(): Q.Lookup<SysParaRow> {
            return Q.getLookup<SysParaRow>('Administration.SysPara');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            SysFg = "SysFg",
            SysGroup = "SysGroup",
            SysName = "SysName",
            SysDesc = "SysDesc",
            SysFgDesc = "SysFgDesc",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            SysGroup1 = "SysGroup1",
            SysGroupSysGroupDesc = "SysGroupSysGroupDesc",
            SysGroupCreateBy = "SysGroupCreateBy",
            SysGroupCreateDate = "SysGroupCreateDate",
            SysGroupUpdateBy = "SysGroupUpdateBy",
            SysGroupLastUpdate = "SysGroupLastUpdate"
        }
    }
}
